<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="19">
            <Button type="primary" @click="modal1=true;detail={state:'上架'}" v-if="power.indexOf(22)!=-1">增加</Button>
            <cite>|</cite>
            <Checkbox @on-change="load" v-model="houtai">按创建时间排序（最新创建在最上面）</Checkbox>
          </Col>
          <Col span="5">
             <Input search enter-button placeholder="输入关键词搜索" v-model="serch.key"  @on-search="load"/>
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%" >
        <el-table-column prop="id" label="编号" width="60" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="name" label="课题名称" :show-tooltip-when-overflow="true">
          <template slot-scope="scope">
            <a @click="m2.mid=scope.row.id;m2.modal=true">{{scope.row.name}}</a>
          </template>
        </el-table-column>
        <el-table-column prop="img" label="秒杀封面图" :show-tooltip-when-overflow="true" width="230">
          <template slot-scope="scope">
            <img :src="'/api/upload/online/'+scope.row.img" style="width:200px;"/>
          </template>
        </el-table-column>
        <el-table-column prop="xj" label="现价" width="80" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="num" label="全部名额" width="80" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="yunum" label="剩余名额" width="80" :show-tooltip-when-overflow="true">
          <template slot-scope="scope">
            {{scope.row.yunum}}
            <span v-if="power.indexOf(23)!=-1">
            | <a @click="m3.modal=true;m3.id=scope.row.id">增加</a>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="上架状态" width="80" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="ztime" label="最近开课时间" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="ctime" label="创建时间" :show-tooltip-when-overflow="true"></el-table-column>

        <el-table-column prop="msg" label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <a @click="edit(scope.row.id)" v-if="power.indexOf(23)!=-1">编辑</a>
            <cite>|</cite>
            <a @click="remove(scope.row.id)" v-if="power.indexOf(24)!=-1">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save">
      <Form :label-width="100">
				<FormItem label="课题名称" required>
					<Input v-model="detail.name"/>
				</FormItem>
				<FormItem label="秒杀封面图" required>
          <UploadOne v-model="detail.img"></UploadOne>
				</FormItem>
				<FormItem label="现价" required>
					<Input v-model="detail.xj"/>
				</FormItem>
				<FormItem label="全部名额" required>
					<InputNumber v-model="detail.num"/>
				</FormItem>
				<FormItem label="上架状态" required>
          <Select v-model="detail.state">
            <Option value="上架" label="上架"></Option>
            <Option value="下架" label="下架"></Option>
          </Select>
				</FormItem>
      </Form>
    </Modal>

    <Drawer title="秒杀课程" :closable="false" v-model="m2.modal" width="60">
      <MsgkkSub :mid="m2.mid"></MsgkkSub>
    </Drawer>


    <Modal
      v-model="m3.modal"
      title="增加余额"
      @on-ok="save3">
      <Form :label-width="100">
        <FormItem label="增加数量" required>
          <input type="number" v-model="m3.num"/>
        </FormItem>
      </Form>
    </Modal>


  </div>
</template>

<script>
  import UploadOne from "../../public/upload/UploadOne";
  import MsgkkSub from "./MsgkkSub";
  export default {
    components:{UploadOne,MsgkkSub},
    data(){
      return{
        power:this.$storage.getSession('power'),
        baseUrl:'/api/miaosha/msgkk/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{},
        serch:{
          key:''
        },
        m2:{
          modal:false,
          mid:0
        },
        m3:{//增加余额
          modal:false,
          num:0,
          id:0,
        },
        loading:false,
        houtai:true,
      }
    },
    methods:{
      save3(){
        let that = this;
        this.$axios.get(this.baseUrl+'addnum?id='+this.m3.id+'&num='+this.m3.num).then(function(rs){
          that.toast(rs.data);
        });
      },
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.id@=@'+this.serch.key);
        }
        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params+'&houtai='+this.houtai).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
          }
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      }
    },
    created(){
      this.load();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/miaosha/Msgkk.vue